import {clientConfig} from '@modifi/client-config'

export const ROUTE_TASKS = '/tasks'

export const ROUTE_NAMES = {
  INDEX: '/',
  ACTIVATION: '/activation',
  BSR_LIST: '/bsr-list',
  TASKS: '/tasks',
  ERROR: '/error',
  COMPANY: '/company-onboarding/:id/profile/',
  MATCH: clientConfig.get('SERVICE_MATCHING_TOOL'),
}
